import { render } from "./xIcon.svg?vue&type=template&id=37319579"
const script = {}
script.render = render

export default script